export function isWebView () {
  let ua = window.navigator.userAgent
  if (ua) {
    return ua.toLowerCase().indexOf('smartloanapp') !== -1
  }
  return false
}

export function isAuWallet () {
  let ua = window.navigator.userAgent
  if (ua) {
    return ua.toLowerCase().indexOf('auwallet') !== -1
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/UserAgent.js